/**
 * System Notice detail view — create/edit wrapper for a single system banner.
 * Dispatches CRUD actions to the entity layer; renders the form in a Paper card.
 */

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import React from 'react';
import { connect } from 'react-redux';

import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';
import { createSystemBanner, fetchSystemBanner, patchSystemBanner } from '@sophocles/entities/SystemBanner/index';
import SystemNoticeForm from '@sophocles/views/admin/forms/SystemNoticeForm';

class SystemNoticeDetailView extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  render() {
    const {
      match: { params },
    } = this.props;
    const { loading } = this.state;

    const pageTitle = `${params.id === 'new' ? 'New' : 'Edit'} System Notice`;

    return (
      <AppNav {...this.props} loading={loading} page="admin_home" notFullHeight={true}>
        <Box sx={{ mx: 2, mt: 1 }}>
          <TitleBar showBackButton title={pageTitle} />
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 'var(--space-3)', md: 'var(--space-4)' },
              borderRadius: 'var(--radius-lg)',
              bgcolor: 'background.paper',
              mb: 2,
            }}
          >
            <SystemNoticeForm {...this.props} />
          </Paper>
        </Box>
      </AppNav>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    fetchSystemBanner: id => dispatch(fetchSystemBanner(id)),
    patchSystemBanner: (id, values) => dispatch(patchSystemBanner(id, values)),
    createSystemBanner: values => dispatch(createSystemBanner(values)),
  };
}

export default connect(null, mapDispatchToProps)(SystemNoticeDetailView);
